import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { getText } from "../../utils/languageUtils";

const QuestionImage = ({ data, language }) => {
    if (!getText(data?.file_path, language)) return null;
    return (
        <div className="d-flex justify-content-center">
            <img src={getText(data?.file_path, language)} alt="quiz-img" style={{ maxHeight: "350px" }} />
        </div>
    )
};

const SingleSelect = React.memo(({ data, language, handleOptionChange, optionMarked, selectedOptions }) => {

    return (
        <div className="textBox pb-1 pt-2 position-relative">
            <div className="shareEmail3 ">

                <div><p>{getText(data.title, language)}</p></div>
                <QuestionImage data={data} language={language} />
                <form className="single-type pt-2">
                    <div className="row justify-content-center text-center">
                        {data?.options?.map((option, index) => (
                            <label key={index}>
                                <input
                                    type="radio"
                                    name="option"
                                    value={option}
                                    checked={
                                        (optionMarked && Number(optionMarked.id) === Number(option.id)) ||
                                        (selectedOptions.values && Number(selectedOptions.values.id) === Number(option.id))
                                    }
                                    onChange={() => handleOptionChange("single_select", data.id, option)}
                                />
                                <span style={{ textAlign: "start" }}>{getText(option.title, language)} </span>

                            </label>
                        ))
                        }
                    </div>
                </form>
            </div>
        </div>
    )
});

const SingleSelectInput = React.memo(({ data, language, handleOptionChange, selectedOptions, translations }) => {

    return (
        <div className="textBox pb-1 pt-2 position-relative">
            <div className="shareEmail3 ">

                <div><p>{getText(data.title, language)}</p></div>
                <QuestionImage data={data} language={language} />
                <form className="single-type pt-2">
                    <div className="row justify-content-center text-center">
                        <textarea
                            className="form-control"
                            placeholder={getText(translations?.write_here, language)}
                            id="floatingTextarea"
                            value={selectedOptions.answer || ''}
                            onChange={(event) => { handleOptionChange('input', data.id, event.target.value) }}
                        ></textarea>
                    </div>
                </form>
            </div>
        </div>
    )
});

const InputRadio = React.memo(({ data, language, handleOptionChange, selectedOptions, optionMarked, textValue, handleTextChange, error }) => {

    let isOption7Selected;
    if (optionMarked && optionMarked.id) {
        isOption7Selected = optionMarked.id === selectedOptions?.input_option_id;
    } else {
        isOption7Selected = selectedOptions?.values?.id === selectedOptions?.input_option_id;
    }



    return (
        <div className="textBox pb-1 pt-2 position-relative">
            <div className="shareEmail3 ">

                <div><p>{getText(data.title, language)}</p></div>
                <QuestionImage data={data} language={language} />
                <form className="single-type pt-2">
                    <div className="row justify-content-center text-center">
                        {data?.options?.map((option, index) => (
                            <label key={index}>
                                <input
                                    type="radio"
                                    name="option"
                                    value={option}
                                    checked={
                                        (optionMarked && Number(optionMarked.id) === Number(option.id))
                                        ||
                                        (selectedOptions.values && Number(selectedOptions.values.id) === Number(option.id))
                                    }
                                    onChange={() => handleOptionChange("input_radio", data.id, option)}
                                />
                                <span style={{ textAlign: "start" }}>{getText(option.title, language)} </span>

                            </label>
                        ))}
                        {isOption7Selected && (
                            <>
                                <input
                                    required
                                    type="text"
                                    className={`form-control ${error ? 'is-invalid' : ''}`}
                                    value={textValue}
                                    onChange={(event) => { handleTextChange(event.target.value) }}
                                />
                                {error && <div className="invalid-feedback" style={{ textAlign: "start" }}>{error}</div>}
                            </>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
})


const MultiSelect = React.memo(({ data, language, handleOptionChange, optionMarked, selectedOptions, handleOtherChange, translations }) => {


    const getChecked = (optionId) => {
        // When server returned previous answers
        if (Array.isArray(optionMarked)) {
            return optionMarked.map(o => Number(o.id)).includes(Number(optionId));
        }
        // When selecting in current session
        if (Array.isArray(selectedOptions?.values)) {
            return selectedOptions.values.map(id => Number(id)).includes(Number(optionId));
        }
        return false;
    };

    const onToggle = (option) => {
        const optionId = option.id;
        let nextValues = Array.isArray(selectedOptions?.values) ? [...selectedOptions.values] : [];
        if (nextValues.map(n => Number(n)).includes(Number(optionId))) {
            nextValues = nextValues.filter(id => Number(id) !== Number(optionId));
        } else {
            nextValues.push(optionId);
        }
        handleOptionChange("multiple_select", data.id, nextValues);
    };

    return (
        <div className="textBox pb-1 pt-2 position-relative">
            <div className="shareEmail3 ">

                <div><p>{getText(data.title, language)}</p></div>
                <QuestionImage data={data} language={language} />
                <form action="" className="boder-bottom-set">
                    {data?.options?.map((option, index) => (
                        <div className="form-check " key={index}>
                            <div className="d-flex  align-items-top">

                                <input
                                    type="checkbox"
                                    name={`option_${option.id}`}
                                    value={getText(option.title, language)}
                                    checked={getChecked(option.id)}
                                    onChange={() => onToggle(option)}
                                    className="form-check-input me-2"
                                />
                                <label className="form-check-label" htmlFor="nda" style={{ lineHeight: "24px", marginTop: 4, }}>
                                    {getText(option.title, language)}
                                </label>
                            </div>
                            {Number(option.has_oth) === 1 && getChecked(option.id) && (
                                <div className="mt-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={selectedOptions.answer || ''}
                                        placeholder={getText(translations.write_here, language)}
                                        onChange={(e) => handleOtherChange(data.id, e.target.value)}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </form>
            </div>
        </div>
    )
});

const QuizQuestionSection = ({
    question,
    handleNextClick,
    handlePreviousClick,
    selectedOptions,
    nextBtnEnable,
    currentPage,
    totalCount,
    finalSubmitReq,
    optionMarked,
    loading,
    language,
    handleOptionChange,
    translationData,
    textValue,
    handleTextChange,
    error,
    handleOtherChange,
    isNoSelectionForCurrent,
    requiresOtherAnswer
}) => {
    const translations = translationData?.baseline || {};
    const typeTranslations = translationData?.endline || {};

    const renderQuestion = (data) => {
        if (!data) return null;

        switch (data.question_type) {
            case "input":
                return <SingleSelectInput data={data} language={language} handleOptionChange={handleOptionChange} selectedOptions={selectedOptions} translations={typeTranslations} />
            case "input_radio":
                return <InputRadio data={data} language={language} handleOptionChange={handleOptionChange} optionMarked={optionMarked} selectedOptions={selectedOptions} textValue={textValue} handleTextChange={handleTextChange} error={error} />
            case "multiple_select":
                return <MultiSelect data={data} language={language} handleOptionChange={handleOptionChange} optionMarked={optionMarked} selectedOptions={selectedOptions} handleOtherChange={handleOtherChange} translations={typeTranslations} />
            case "single_select":
            default:
                return <SingleSelect data={data} language={language} handleOptionChange={handleOptionChange} optionMarked={optionMarked} selectedOptions={selectedOptions} />
        }
    }
    return (
        <div className="container-fluid px-0 background-image">
            <div className="row justify-content-center">
                <div className="col-xxl-5 col-xl-7 col-lg-8 col-md-12">
                    <section className="my-3">
                        <div className="container-fluid">
                            <>
                                {renderQuestion(question?.survey_question[0])}

                                <div className="row">
                                    <div className="col-12">
                                        <div className="mark-buttons d-flex justify-content-between " style={{ marginTop: 150, marginBottom: 100 }}>
                                            <div className="left-btn"> <button onClick={handlePreviousClick}
                                                disabled={Number(currentPage) === 1}
                                                className="previous_btn_baseline"
                                            >
                                                <FontAwesomeIcon icon={faArrowLeft} size="lg" color="#fff" />
                                            </button>

                                            </div>

                                            {Number(currentPage) === Number(totalCount) ? <div className="markButtons"> <button
                                                className="d-flex align-items-center gap-2"
                                                onClick={() => { finalSubmitReq() }}
                                                style={{ backgroundColor: nextBtnEnable === false ? "#c8c8c8" : isNoSelectionForCurrent || requiresOtherAnswer ? "#c8c8c8" : loading ? "#c8c8c8" : "#792110", color: nextBtnEnable === false ? "#212529" : isNoSelectionForCurrent || requiresOtherAnswer ? "#212529" : loading ? "#212529" : "#ffffff" }}
                                                disabled={nextBtnEnable === false ? true : isNoSelectionForCurrent || requiresOtherAnswer ? true : loading ? true : false}
                                            >
                                                {getText(translations.submit, language)}

                                            </button>
                                            </div>
                                                : ""}
                                            <div className="right-btn">
                                                <button
                                                    type="button"
                                                    className="previous_btn_baseline"
                                                    onClick={handleNextClick}
                                                    disabled={
                                                        Number(currentPage) === Number(totalCount)
                                                            ? true
                                                            : !nextBtnEnable ||
                                                              isNoSelectionForCurrent ||
                                                              requiresOtherAnswer ||
                                                              loading
                                                    }
                                                    style={{
                                                        backgroundColor:
                                                            Number(currentPage) === Number(totalCount)
                                                                ? "#c8c8c8"
                                                                : !nextBtnEnable ||
                                                                  isNoSelectionForCurrent ||
                                                                  requiresOtherAnswer ||
                                                                  loading
                                                                  ? "#c8c8c8"
                                                                  : "#792110",
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faArrowRight} size="lg" color="#fff" />
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>

                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}

export default QuizQuestionSection
